/* 🤖 this file was generated by svg-to-ts */
export const iconAzk: {
  name: 'azk';
  data: string;
} = {
  name: 'azk',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="#9896FF" stroke-width="2" d="M16 31c8.284 0 15-6.716 15-15S24.284 1 16 1 1 7.716 1 16s6.716 15 15 15Z"/><g clip-path="url(#azk__circleClip)"><g style="transform:scale(.8125);transform-origin:50% 50%"><path fill="#000" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="m4.08 16 6.81-6.81v3.4h6.81l-6.81 5.11v5.11zm23.84 0-6.81 6.81v-3.4H14.3l6.81-5.11V9.19z"/></g></g><defs><clipPath id="azk__circleClip"><circle cx="16" cy="16" r="13"/></clipPath></defs></svg>`,
};
